import { useEffect, useMemo, useState } from "react";
import type { KnownCar } from "../api/client";

interface AddCarDialogProps {
  open: boolean;
  isLoading: boolean;
  knownCars: KnownCar[];
  existingSlugs: Set<string>;
  error: string | null;
  onClose: () => void;
  onPick: (car: KnownCar) => void;
}

export function AddCarDialog({
  open,
  isLoading,
  knownCars,
  existingSlugs,
  error,
  onClose,
  onPick,
}: AddCarDialogProps) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!open) {
      setQuery("");
    }
  }, [open]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) {
      return knownCars;
    }
    return knownCars.filter((car) =>
      `${car.slug} ${car.name} ${car.make ?? ""} ${car.model ?? ""}`
        .toLowerCase()
        .includes(q),
    );
  }, [knownCars, query]);

  if (!open) {
    return null;
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal">
        <div className="modal-header">
          <div>
            <h3>添加车型</h3>
            <p className="muted">从知识库挑一辆，作为新项目的起点。</p>
          </div>
          <button className="icon-button" type="button" onClick={onClose}>
            关闭
          </button>
        </div>
        <input
          type="search"
          className="modal-search"
          placeholder="搜索车型 (例如 BRZ 或 tesla)"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
        {error ? <div className="inline-error">{error}</div> : null}
        {isLoading ? (
          <p className="muted modal-empty">加载车型库中...</p>
        ) : filtered.length === 0 ? (
          <p className="muted modal-empty">没有匹配的车型。</p>
        ) : (
          <ul className="car-picker-list">
            {filtered.map((car) => {
              const already = existingSlugs.has(car.slug);
              return (
                <li key={car.slug}>
                  <button
                    type="button"
                    className={`car-picker-item ${already ? "already" : ""}`}
                    onClick={() => onPick(car)}
                  >
                    <span className="car-picker-name">{car.name}</span>
                    <span className="car-picker-slug">{car.slug}</span>
                    {already ? <span className="car-picker-badge">已添加</span> : null}
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
